/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ProfileDetailData} from '../../../../Redux/AdminPanel/ProfileDetailsSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  userAccountList: [],
  AccountIdList: [],
  GetAllAccountManager: [],
  GetAllSales: [],
  notes: [],
  newUsers: [],
}

export const CreateUserAccount: any = createAsyncThunk(
  '/CreateUserAccount',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}/admin/createUserAccount`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(GetAllUserAccount())

    return response.data
  }
)

export const GetAllUserAccount: any = createAsyncThunk(
  '/GetAllUserAccount',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/getAllUserAccount`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)
export const GetAllAccountId: any = createAsyncThunk(
  '/GetAllAccountId',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/whiteLabelDropdownList`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)

export const UpdateUserAccount: any = createAsyncThunk(
  '/UpdateUserAccount',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.put(
      `${API_URL}admin/updateUserAccount/${data?._id}`,
      data.data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(GetAllUserAccount({page: data.page}))
    thunkApi.dispatch(ProfileDetailData(data?._id))

    return response.data
  }
)

export const DeleteUserAccount: any = createAsyncThunk(
  '/DeleteUserAccount',
  async (data, thunkApi) => {
    const response: any = await axios.post(`${API_URL}admin/deleteStaffAdmin`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllUserAccount())

    return response.data
  }
)
export const UpdateStatus: any = createAsyncThunk(
  '/updateStatus',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/updateStatus`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllUserAccount())
    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }
    return response.data
  }
)
export const updatePassword: any = createAsyncThunk(
  '/updatePassword',
  async (data: any, thunkApi: any) => {
    const response: any = await axios
      .post(`${API_URL}admin/updatePassword`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => {
        toast.success('Password updated successfully!')
      })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllUserAccount({role: 'user'}))

    return response.data
  }
)
export const resetPassword: any = createAsyncThunk(
  '/resetPassword',
  async (data: any, thunkApi: any) => {
    const response: any = await axios
      .post(`${API_URL}auth/reset-password`, data, {})
      .then((res) => {
        res?.data?.status && toast.success('Password updated successfully!')
      })

    return response.data
  }
)

export const getAccountManageList: any = createAsyncThunk(
  '/getAccountManageList',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/getStaffWithoutPagination`, {
      params: {role: 'accountManager'},
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)
export const getSalesList: any = createAsyncThunk('/getSalesList', async (data: any, thunkApi) => {
  const response: any = await axios.get(`${API_URL}admin/getStaffWithoutPagination`, {
    params: {role: 'sales,staffAdmin'},
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })

  thunkApi.dispatch(stopLoading())

  return response.data
})

export const GetUserNotes: any = createAsyncThunk('/GetUserNotes', async (data: any, thunkApi) => {
  const response: any = await axios.get(`${API_URL}notes/659fb4304bc3bf29463b2418`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })

  thunkApi.dispatch(stopLoading())

  return response.data
})

export const AddUserNotes: any = createAsyncThunk(
  '/AddUserNotes',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}notes`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    // thunkApi.dispatch(GetUserNotes())
    return response.data
  }
)

export const DeleteUserNotes: any = createAsyncThunk('/DeleteUserNotes', async (data, thunkApi) => {
  const response: any = await axios.delete(`${API_URL}notes/${data}`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })

  // thunkApi.dispatch(GetUserNotes())
  return response.data
})

export const UpdateUserNotes: any = createAsyncThunk(
  '/UpdateUserNotes',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.put(`${API_URL}notes/${data?._id}`, data.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    // thunkApi.dispatch(GetUserNotes())
    return response.data
  }
)

export const GetNewUserList: any = createAsyncThunk(
  '/GetNewUserList',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/getAllUserAccountDashboard`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)

export const UpdateUserData: any = createAsyncThunk(
  '/UpdateUserData',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.put(`${API_URL}admin/userUpdate/${data?._id}`, data.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    // thunkApi.dispatch(GetUserNotes())
    return response.data
  }
)

const UserAccount = createSlice({
  name: 'UserAccount',
  initialState,
  reducers: {},
  extraReducers: {
    [GetAllUserAccount.fulfilled]: (state, {payload}) => {
      return {...state, userAccountList: payload?.data}
    },
    [CreateUserAccount.fulfilled]: (state, {payload}) => {
      {
        payload.status === true ? toast.success(payload.message) : toast.error(payload.message)
      }
    },
    [GetAllAccountId.fulfilled]: (state, {payload}) => {
      return {...state, AccountIdList: payload?.data}
    },
    [getAccountManageList.fulfilled]: (state, {payload}) => {
      return {...state, GetAllAccountManager: payload?.data}
    },
    [getSalesList.fulfilled]: (state, {payload}) => {
      return {...state, GetAllSales: payload?.data}
    },
    [GetUserNotes.fulfilled]: (state, {payload}) => {
      return {...state, notes: payload?.data}
    },
    [GetNewUserList.fulfilled]: (state, {payload}) => {
      return {...state, newUsers: payload?.data}
    },
  },
})

export const getAccountIdList = (state: any) => state?.UserAccount?.AccountIdList
export const getAllAccountManagerList = (state: any) => state?.UserAccount?.GetAllAccountManager
export const getAllSalesList = (state: any) => state?.UserAccount?.GetAllSales
export const getUserNotesList = (state: any) => state?.UserAccount?.notes
export const getNewUsersList = (state: any) => state?.UserAccount?.newUsers

export default UserAccount.reducer
